import { render, staticRenderFns } from "./CatalogProductSettingClothingVariants.vue?vue&type=template&id=68e844e2&scoped=true&"
import script from "./CatalogProductSettingClothingVariants.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingClothingVariants.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingClothingVariants.vue?vue&type=style&index=0&id=68e844e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e844e2",
  null
  
)

export default component.exports